import { AgGridReact } from 'ag-grid-react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { getGenericMasterFilteredListByKey, getGridDataByModuleKey } from '../../redux/selector';
import { fetchContactsAndAppendToModule } from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import apiServices from '../../services/service';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { contactInputData, handleGridSearch } from '../../shared/constants';
import CustomPagination from './grid/customPagination';

const ChildContact = ({ module, localData, id, hasUpdateContactPermission }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [showPopup3, setShowPopup3] = useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedRows, setSelectedRows] = useState(null);
  const [editData, setEditData] = useState([]);
  const [deleteData, setDeleteData] = useState([]);
  const gridRef = useRef();
  const localGridRef = useRef(null);
  const [selectedRowsPopup, setSelectedRowsPopup] = useState([]);
  const gridData = useSelector(getGridDataByModuleKey('contactList'));
  const location = useLocation();
  const [searchText, setSearchText] = useState(gridData?.inputPayload?.searchText || '');
  const [isFocused, setIsFocused] = useState(false);

  const [localContactInputPayload, setLocalContactInputPayload] = useState({
    ...contactInputData,
    module: module,
    moduleId: localData?.id,
  });

  const [totalCount, setTotalCount] = useState(0);

  let hasInfoContactPermission = true;
  let userUIControlPermission = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.contactmenu;
  if (userUIControlPermission) {
    hasInfoContactPermission = userUIControlPermission?.contactinfoscreen
      ? userUIControlPermission.contactinfoscreen.canView
      : true;
  }

  const gridApiRef = useRef(null);
  const onSelectionChanged = (event) => {
    setSelectedRows(event.api.getSelectedRows()); // Get all selected rows
  };

  const onSelectionChangedPopup = (event) => {
    setSelectedRowsPopup(event.api.getSelectedRows()); // Get all selected rows
  };

  const [contactListAll, setContactListAll] = useState(null);

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
  };

  useEffect(() => {
    fetchCampaign();
  }, [localContactInputPayload.pageNumber, localContactInputPayload?.pageSize, localData?.id]);

  const fetchCampaign = async () => {
    if (!localData?.id) return;
    if (searchText) {
      localContactInputPayload.searchText = searchText;
    } else {
      localContactInputPayload.searchText = null;
    }
    gridApiRef.current?.showLoadingOverlay();
    setLoading(true);

    try {
      const res = await apiServices.getContactList(localContactInputPayload);
      const contacts = res.data.contacts || [];

      setContactListAll(contacts);
      setTotalCount(res.data.totalCount || 0);

      if (contacts.length === 0) {
        gridApiRef.current?.showNoRowsOverlay();
      } else {
        gridApiRef.current?.hideOverlay();
      }
    } catch (error) {
      console.error('Error fetching campaigns', error);
      gridApiRef.current?.showNoRowsOverlay();
    } finally {
      setLoading(false);
    }
  };

  const clearSearch = async () => {
    setSearchText('');

    const payload = {
      ...localContactInputPayload,
      pageNumber: 1,
      searchText: '',
    };

    try {
      gridApiRef.current?.showLoadingOverlay(); // ✅ Show loading before fetch
      setLoading(true);

      const res = await apiServices.getContactList(payload);
      const contacts = res.data.contacts || [];

      setContactListAll(contacts);
      setTotalCount(res.data.totalCount || 0);

      if (contacts.length === 0) {
        gridApiRef.current?.showNoRowsOverlay(); // ✅ No rows
      } else {
        gridApiRef.current?.hideOverlay(); // ✅ Data present
      }
    } catch (error) {
      console.error('Search Clear Error', error);
      gridApiRef.current?.showNoRowsOverlay(); // ✅ On error
    } finally {
      setLoading(false);
    }
  };

  const memberStatus = useSelector(getGenericMasterFilteredListByKey('MemberStatusCrm'));

  const campaignColumnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerName: '',
      maxWidth: 50,
      suppressSizeToFit: true,
    },
    { headerName: 'Full Name', field: 'fullName', width: 150 },
    { headerName: 'Email', field: 'email', width: 150 },
    { headerName: 'Phone', field: 'phone', width: 150 },
    { headerName: 'Contact Owner', field: 'owner', width: 150 },
    { headerName: 'Title', field: 'title', width: 150 },
  ];

  const localCampaignColumnDefs = [
    {
      headerName: 'Actions',
      cellRenderer: (params) => {
        const paramsValue = { ...params.data };
        return (
          <div className="action-menu">
            {hasUpdateContactPermission && (
              <>
                <img
                  src="/assets/images/edit.png"
                  className="action-img1"
                  onClick={() => handleClickEdit(paramsValue)}
                  alt="Edit Contact"
                  title="Edit Contact"
                ></img>
                {location.pathname.includes('campaign') && (
                  <img
                    src="/assets/images/trash.png"
                    className="action-img2"
                    onClick={() => openPopup3(paramsValue)}
                    alt="Delete Contact"
                    title="Delete Contact"
                  />
                )}
              </>
            )}
          </div>
        );
      },
      maxWidth: 120,
      sortable: false,
      filter: false,
      pinned: 'left',
    },
    {
      headerName: 'Full Name',
      field: 'name',
      width: 150,
      filter: 'agSetColumnFilter',
      cellRenderer: (params) => {
        if (!params.value || params.node.group) return params.value;

        // Conditionally render link based on permission
        return hasInfoContactPermission ? (
          <Link
            to={`/contacts/viewContact?id=${params.data.id}&pageNo=${gridData?.inputPayload?.pageNumber}`}
            state={params.data}
            style={{ fontWeight: '600' }}
          >
            {params.value}
          </Link>
        ) : (
          <span style={{ fontWeight: '600' }}>{params.value}</span>
        );
      },
    },
    { headerName: 'Account', field: 'account', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Email', field: 'email', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Owner', field: 'owner', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Title', field: 'title', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'State', field: 'state', width: 150, filter: 'agSetColumnFilter' },
    location.pathname.includes('campaign')
      ? {
          headerName: 'Member Status',
          field: 'memberStatus',
          width: 150,
          filter: 'agSetColumnFilter',
        }
      : null,
  ].filter(Boolean);

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        {
          statusPanel: () => (
            <CustomPagination
              inputPayload={localContactInputPayload}
              setInputPayload={setLocalContactInputPayload}
              totalCount={totalCount}
            />
          ),
          align: 'center',
        },
      ],
    };
  }, [localContactInputPayload, totalCount]);

  const onSearch = (searchValue) => {
    handleGridSearch({
      searchValue,
      apiMethod: apiServices.getContactList,
      gridApiRef,
      inputPayload: localContactInputPayload,
      setData: setContactListAll,
      setTotalCount,
      setLoading,
    });
  };

  const onFilterTextBoxChangedLocal = useCallback(() => {
    localGridRef.current.api.setQuickFilter(document.getElementById('filter-text-box1').value);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const trimmedText = searchText.trim();
      if (trimmedText) {
        onSearch(trimmedText);
      } else {
        clearSearch(); // <--- this ensures it resets with empty searchText
      }
    }
  };

  const viewCampaign = (params) => {
    alert(`Viewing campaign: ${params.data.campaignName}`);
  };

  const editCampaign = (params) => {
    alert(`Editing campaign: ${params.data.campaignName}`);
  };

  const deleteCampaign = (params) => {
    alert(`Deleting campaign: ${params.data.campaignName}`);
  };

  const frameworkComponents = {
    checkboxRenderer: (props) => {
      const handleChange = (e) => {
        const isSelected = props.node.isSelected();
        props.node.setSelected(!isSelected); // Toggle the selection state of the row
      };

      return <input type="checkbox" checked={props.node.isSelected()} onChange={handleChange} />;
    },
  };
  const navigate = useNavigate();
  const handleOpenContactAdd = () => {
    navigate('/contacts/addContact');
  };
  const handleOpen = () => {
    setIsOpen(true);
    fetchCampaign();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const openPopup2 = () => {
    setShowPopup2(true);
  };

  const closePopup2 = () => {
    setShowPopup2(false);
  };
  // Function to close the third popup
  const closePopup3 = () => {
    setShowPopup3(false);
  };

  // Function to open the third popup
  const openPopup3 = (data) => {
    setShowPopup3(true);
    setDeleteData(data);
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;

    const updatedFormData = {
      ...formData,
      [name]: selectedId,
      [`${name}Name`]: selectedValue,
    };
    if (name === 'memberStatusId') {
      setFormData({
        ...formData,
        memberStatusId: selectedValue,
        memberStatus: selectedId,
      });
    }
  };

  useEffect(() => {
    const plannedOption = memberStatus?.find((option) => option.displayName === 'Planned');

    if (plannedOption) {
      setSelectedOptions((prevState) => ({
        ...prevState,
        memberStatusId: plannedOption.id,
      }));

      setFormData((prevState) => ({
        ...prevState,
        memberStatus: plannedOption.id,
        memberStatusId: plannedOption.displayName,
      }));
    }
  }, [memberStatus, showPopup2]);

  const handleSubmit = async (formData) => {
    setLoading(true);
    const selectedIds = selectedRowsPopup.map((row) => row.id);

    if (formData.type === 'edit') {
      const data = {
        ...formData,
        moduleId: formData.id,
        campaignId: id,
        module: 'Contact',
      };

      await apiServices
        .updateCampaignByModule(data)
        .then((response) => {
          if (response.status === 200) {
            setShowPopup2(false);
            dispatch(
              fetchContactsAndAppendToModule({
                moduleName: module,
                id: localData?.id,
              })
            );

            toast.success('Contact Updated Successfully!', {
              position: 'top-right',
            });
          }
        })
        .catch((error) => {
          console.error('Error updating contacts:', error);
          toast.error('Failed to update contacts.', { position: 'top-right' });
        });
    } else {
      const data = {
        ...formData,
        contactId: selectedIds,
        campaignId: [id],
      };

      await apiServices
        .addCampaignFromContact(data)
        .then((response) => {
          if (response.status === 200) {
            setSelectedRowsPopup([]);
            handleClose();
            dispatch(
              fetchContactsAndAppendToModule({
                moduleName: module,
                id: id,
              })
            );

            toast.success('Contact Added Successfully!', {
              position: 'top-right',
            });
          }
        })
        .catch((error) => {
          console.error('Error adding contacts:', error);
          toast.error('Failed to add contacts.', { position: 'top-right' });
        });
    }

    // }

    setLoading(false);
    setFormData([]);
  };
  const handleClickDeleteContact = (paramsValue) => {
    setLoading(true);
    const selectedIds = selectedRows?.map((row) => row.id);
    // Creating the desired JSON object
    const data = {
      campaignId: localData.id,
      module: 'Contact',
      moduleId: selectedRows?.length > 0 ? selectedIds : [paramsValue?.id],
    };
    console.log('Data==>>', data);
    apiServices
      .deleteCampaignByModule(data)
      .then((response) => {
        if (response.status === 200) {
          setShowPopup3(false);
          setSelectedRows([]);
          dispatch(
            fetchContactsAndAppendToModule({
              moduleName: module,
              id: localData?.id,
            })
          );
          setLoading(false);
          toast.success('Contact unassigned successfully!', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error while unassigning contact:', error);
        setLoading(false);
      });
  };

  const handleClickEdit = (data) => {
    if (location.pathname.includes('campaign')) {
      setShowPopup2(true);
      setEditData({
        ...data,
        type: 'edit',
      });
    } else {
      navigate('/contacts/editContact', {
        state: { ...data, type: 'edit' },
      });
    }
  };
  return (
    <div className="row" id="campainview">
      <div className="col-12 col-sm-12 col-md-12">
        <div className="infoBox">
          <div className="addlead-header">
            <label htmlFor="" className="flex-div align-items-center">
              <img className="me-2" src="../assets/images/contatctIcon.svg" alt="" />
              Contacts(
              {location.pathname.includes('campaign')
                ? localData?.contact?.length
                : localData?.contacts?.length}
              )
            </label>
            {hasUpdateContactPermission &&
              (location.pathname.includes('campaign') ? (
                <button
                  type="button"
                  className="btn btn-outline-primary attBtn"
                  onClick={handleOpen}
                >
                  Assign Contact
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-outline-primary attBtn"
                  onClick={handleOpenContactAdd}
                >
                  Add Contact
                </button>
              ))}
          </div>
          <div className="leadcontent" style={{ pointerEvents: 'unset' }}>
            <>
              <div className="row">
                <div className="col-12 col-md-12">
                  <div id="view_leadtable">
                    <div className="heading_item">
                      <input
                        className="form-control"
                        id="filter-text-box1"
                        type="Text"
                        placeholder="Search..."
                        onInput={onFilterTextBoxChangedLocal}
                      />
                    </div>
                    <div className="cutome_ag_theme " style={{ marginTop: '1rem' }} id="withFilter">
                      <div className="ag-theme-balham tbl_height">
                        <AgGridReact
                          rowData={
                            location.pathname.includes('campaign')
                              ? localData?.contact
                              : localData?.contacts
                          }
                          columnDefs={localCampaignColumnDefs}
                          defaultColDef={{
                            flex: 1,
                            minWidth: 100,
                            resizable: true,
                          }}
                          suppressRowClickSelection={true}
                          rowSelection="multiple"
                          sideBar={sideBar}
                          alwaysShowVerticalScroll={true}
                          ref={localGridRef}
                          onSelectionChanged={onSelectionChanged}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>

          {/* Modal structure Add To Campaigns */}
          {/* Popup */}
          {isOpen && (
            <div className="popup-backdrop">
              <div className="popup">
                {/* Popup Header */}
                <div className="popup-header">
                  <h4 className="popup-title">
                    Add Campaigns to Contact : {localData?.campaignName}
                  </h4>
                  <button className="custom-btn-close" onClick={handleClose}></button>
                </div>
                {/* Popup Body */}
                <div className="popup-body">
                  <div className="popupbody_header">
                    <div className="hd_leftview">
                      <div className="heading_item" id="contct_search">
                        <div className="search-container">
                          <input
                            type="text"
                            className={`form-control${searchText ? ' focused' : ''}`}
                            placeholder="Search..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            onKeyDown={handleKeyDown}
                          />

                          {searchText && (
                            <span className="clear-btn" onClick={clearSearch}>
                              &times;
                            </span>
                          )}
                          <button
                            className="contactsearch"
                            type="button"
                            onClick={() => onSearch(searchText)}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <circle cx="11" cy="11" r="8"></circle>
                              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                          </button>
                        </div>
                        <i className="icon_tt"></i>
                      </div>

                      <div className="flx_heding view_fnt" id="action_dropdown">
                        <>
                          <label htmlFor="memberStatusId" style={{ width: '100px' }}>
                            Member Status:
                          </label>
                          <Select
                            id="memberStatus"
                            value={selectedOptions.memberStatus}
                            placeholder={formData.memberStatusId}
                            onChange={(selectedOption) =>
                              handleChange(selectedOption, 'memberStatusId')
                            }
                            options={memberStatus?.map((data) => ({
                              value: data.id,
                              label: data.displayName,
                            }))}
                            styles={{
                              container: (base) => ({
                                ...base,
                                width: '200px',
                                minHeight: '30',
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: '9999',
                                height: '200px',
                                overflow: 'auto',
                                color: '#000',
                              }),
                              control: (base) => ({
                                ...base,
                                borderRadius: '6px',
                              }),
                            }}
                          />
                        </>
                      </div>
                    </div>
                    <div className="hd_rightview" id="update_campaign">
                      <div className="flx_heding view_fnt">
                        <label>
                          Total Records: <span>{totalCount}</span>
                        </label>
                      </div>
                      <span className="separator"></span>

                      <div className="flx_heding">
                        <button
                          className="add-btn"
                          type="button"
                          onClick={() => handleSubmit(formData)}
                          disabled={!selectedRowsPopup.length > 0 || loading}
                        >
                          {selectedRowsPopup.length > 0 && loading && (
                            <>
                              {' '}
                              <div
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              ></div>
                            </>
                          )}
                          {selectedRowsPopup.length > 0 && loading
                            ? 'Loading...'
                            : `Add to ${module}`}
                        </button>
                      </div>

                      {/* Popup 2 Overlay */}
                    </div>
                  </div>
                  <div className="cutome_ag_theme" style={{ marginTop: '1rem' }}>
                    <div
                      className="ag-theme-balham tbl_height"
                      style={{
                        height: 'calc(100vh - 310px)',
                        width: '100%',
                        overflow: 'auto',
                      }}
                    >
                      <AgGridReact
                        rowData={contactListAll}
                        columnDefs={campaignColumnDefs}
                        frameworkComponents={frameworkComponents}
                        defaultColDef={{
                          flex: 1,
                          minWidth: 100,
                          resizable: true,
                        }}
                        rowSelection="multiple"
                        // onSelectionChanged={onSelectionChanged}
                        ref={gridRef}
                        onSelectionChanged={onSelectionChangedPopup}
                        statusBar={statusBar}
                        onGridReady={onGridReady}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showPopup2 && (
            <div id="genricPopup">
              <div className="popup-backdrop">
                <div className="popup-overlay">
                  <div className="popup">
                    {/* Popup Header */}
                    <div className="popup-header">
                      <h4 className="popup-title">Update Campaign Member Status</h4>
                      <button className="custom-btn-close" onClick={closePopup2}></button>
                    </div>

                    {/* Popup Body */}
                    <div className="popup-body" style={{ color: '#000', zIndex: '1050' }}>
                      <div className="row">
                        <div className="col-12 col-md-12">
                          <div className="input-container">
                            <>
                              <label htmlFor="memberStatusId">Member Status</label>
                              <Select
                                value={selectedOptions.memberStatusId}
                                placeholder={editData.memberStatus || 'Select Status'}
                                onChange={(selectedOption) =>
                                  handleChange(selectedOption, 'memberStatusId')
                                }
                                options={memberStatus?.map((data) => ({
                                  value: data.id,
                                  label: data.displayName,
                                }))}
                                menuPortalTarget={document.body}
                                styles={{
                                  container: (base) => ({
                                    ...base,
                                    width: '100%',
                                    zIndex: '9999',
                                  }),
                                  control: (base, state) => ({
                                    ...base,
                                    borderRadius: '5px',
                                    border: state.isFocused
                                      ? '2px solid #365397'
                                      : '1px solid #ccc',
                                    boxShadow: state.isFocused ? '0 0 5px #365397' : 'none', // Focus shadow
                                    transition: 'border-color 0.3s, box-shadow 0.3s',
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: '99999', // Dropdown z-index
                                    maxHeight: '150px', // Limit dropdown height
                                    overflowY: 'auto', // Scroll if items exceed height
                                  }),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: '99999', // Rendered dropdown above everything
                                  }),
                                  option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isFocused
                                      ? '#365397' // Hover background
                                      : state.isSelected
                                        ? 'rgba(54, 83, 151, 0.2)' // Selected background
                                        : '#fff', // Default background
                                    color: state.isFocused || state.isSelected ? '#fff' : '#000', // Text color
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s, color 0.3s',
                                  }),
                                  singleValue: (base) => ({
                                    ...base,
                                    padding: '5px',
                                    borderRadius: '3px',
                                  }),
                                }}
                              />
                            </>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Popup Footer */}
                    <div className="popup-footer" id="unassign-popup">
                      <button className="btn btn-outline-primary" onClick={closePopup2}>
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={() =>
                          handleSubmit({
                            ...formData,
                            id: editData.id,
                            type: 'edit',
                          })
                        }
                      >
                        Save
                      </button>

                      {/* Popup 3 Overlay */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showPopup3 && (
            <div id="unassign-popup">
              <div className="popup-overlay">
                <div
                  className="popup"
                  style={{
                    width: '50%',
                    textAlign: 'center',
                    padding: '20px',
                    zIndex: '9999',
                    background: 'white',
                  }}
                  // style={{
                  //   padding: "20px",
                  // }}
                >
                  {/* Popup Body */}
                  <div className="popup-body">
                    <div className="row">
                      <div className="col-12 col-md-12">
                        <div className="unassign-txt">
                          <p>
                            Unassign {deleteData.firstName} {deleteData.middleName}{' '}
                            {deleteData.lastName} from {localData.campaignName} ?
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Popup Footer */}
                  <div className="unassign-footer">
                    <button className="btn btn-outline-primary" onClick={closePopup3}>
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleClickDeleteContact(deleteData)}
                      disabled={loading}
                    >
                      {loading && (
                        <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                      )}
                      {loading ? 'Loading...' : 'Unassign'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChildContact;
